import React, { useState } from "react";
import { Link } from "react-router-dom";
import MainContent from "@components/content";
import Timeline from "@components/timeline";
import css from "../index.module.css";

const timelineData = [
  {
    status: "Проблема",
    date: "Июнь 2025",
    title: "Сбои в работе CloudFlare",
    color: "danger",
    description:
      "Массовые проблемы с доступом к сайтам, использующим инфраструктуру (CDN) и защиту CloudFlare на территории РФ.",
  },
  {
    status: "Роскомнадзор",
    date: "Июль 2025",
    title: "Направление запроса",
    color: "warning",
    description:
      "Подача официального обращения в Роскомнадзор с требованием разъяснить причины ограничения доступа и указать правовые основания для блокировки.",
  },
  {
    status: "Роскомнадзор",
    date: "Август 2025",
    title: "Официальный ответ ведомства",
    color: "success",
    description:
      "Получен ответ об отсутствии целенаправленных блокировок. РКН официально заявил, что ограничения к инфраструктуре CloudFlare не применялись.",
  },
];

const initialCaseStatus = {
  label: "Рассмотрено",
  code: "considered",
  variant: "default",
};

const LegalCase3Page = () => {
  const [caseStatus] = useState(initialCaseStatus);

  return (
    <MainContent>
      <div className={css.casePage}>
        <div className={css.caseHeader}>
          <div className={css.caseHeaderTop}>
            <Link to="/legal" className={css.backLink}>
              <span className={css.backIcon}>←</span>
              <span>Назад к делам</span>
            </Link>
            <div
              className={`${css.caseStatus} ${
                css[`caseStatus_${caseStatus.variant}`]
              }`}
            >
              <span className={css.caseStatusDot} />
              <span className={css.caseStatusText}>{caseStatus.label}</span>
            </div>
          </div>
          <h1>Ограничение доступа к CloudFlare</h1>
          <span className={css.caseMeta}>
            Федеральное законодательство · 2025 г.
          </span>
        </div>

        <div className={css.caseLayout}>
          <div className={css.caseDescription}>
            <div className={css.caseSection}>
              <div className={css.caseSectionTitle}>Суть (фабула)</div>
              <p>
                В период массовых сбоев и недоступности ресурсов, использующих CDN и DNS-сервисы CloudFlare в России, возникла необходимость выяснить правовые основания для блокировки глобальной IT-инфраструктуры, от которой зависит работа миллионов легальных сайтов. Направлен запрос в Роскомнадзор.
              </p>
            </div>

            <div className={css.caseSection}>
              <div className={css.caseSectionTitle}>Моя позиция</div>
              <p>
                Блокировка инфраструктурных IP-адресов CloudFlare целиком нарушает принцип соразмерности и ограничивает доступ к огромному числу ресурсов, не внесенных в реестр запрещенной информации. Если блокировка осуществляется с помощью ТСПУ (технических средств противодействия угрозам), ведомство обязано предоставить законные основания для таких мер.
              </p>
            </div>

            <div className={css.caseSection}>
              <div className={css.caseSectionTitle}>Позиция ведомства</div>
              <p>
                В своем официальном ответе Роскомнадзор полностью отрицал факт применения каких-либо ограничительных мер.
              </p>
            </div>

            <div className={css.caseSection}>
              <div className={css.caseSectionTitle}>Итог (резюме)</div>
              <p>
                Разбирательство завершилось получением официального письма от регулятора с отрицанием факта блокировки. Дальнейшее обжалование потеряло процессуальный смысл, так как предмет спора формально отсутствовал.
              </p>
            </div>

            <div className={css.caseSection}>
              <div className={css.caseSectionTitle} style={{ margin: 0 }}>Материалы</div>
              <div className={css.caseMaterialsList}>
                <a href="https://dash.leecyber.com/drive/shared/cc8fa4fa-f605-4a42-a147-8463a3b7048e" className={css.caseMaterialLink} target="_blank" rel="noreferrer">
                  Официальный ответ Роскомнадзора
                </a>
              </div>
            </div>
          </div>

          <div className={css.caseTimeline}>
            <div className={css.caseSectionTitle} style={{ marginBottom: 25 }}>Ход дела</div>
            <Timeline data={timelineData} />
          </div>
        </div>
      </div>

      <p className={css.caseDisclaimer}>
        Все представленные дела — результат моей самостоятельной практики. Опубликованные материалы не являются профессиональной юридической консультацией, носят исключительно ознакомительный характер и отражают мое субъективное мнение.
      </p>
    </MainContent>
  );
};

export default LegalCase3Page;